import { render, staticRenderFns } from "./WalletTransactions.vue?vue&type=template&id=1316b944&scoped=true&"
import script from "./WalletTransactions.vue?vue&type=script&lang=js&"
export * from "./WalletTransactions.vue?vue&type=script&lang=js&"
import style0 from "./WalletTransactions.vue?vue&type=style&index=0&id=1316b944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1316b944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VPagination})
